module.exports = __webpack_public_path__ + "static/media/iconEr.ecc03994.svg";